import FormattedMessage from 'I18n/components/FormattedMessage';
import { getFullUrl } from 'hubspot-url-utils';
import getPrivacyPolicyLink from '../utils/getPrivacyPolicyLink';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FaceNavFooter = () => {
  return /*#__PURE__*/_jsx(View, {
    padding: "400",
    children: /*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "small",
        color: "text-core-default",
        children: /*#__PURE__*/_jsx(Link, {
          href: `${getFullUrl('app')}/login-api/v1/logout/all`,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.faceNav.signOut"
          })
        })
      }), /*#__PURE__*/_jsx(Text, {
        as: "small",
        color: "text-core-default",
        children: /*#__PURE__*/_jsx(Link, {
          href: getPrivacyPolicyLink(),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.faceNav.privacy"
          })
        })
      })]
    })
  });
};